// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b7cec7da","455":"43141559","488":"86708a04","977":"15be0e5a"}[chunkId] + ".chunk.js";
};